<template>
  <el-config-provider :locale="zhCn">
    <div v-if="isMobile() && $route.path === '/'">
      <Mobile></Mobile>
    </div>
    <RouterView v-else />
  </el-config-provider>
</template>

<script setup lang="ts">
import { dayjs } from 'element-plus'
import { zhCn } from 'element-plus/es/locale/index.mjs'
import { onBeforeUnmount, onMounted, provide, reactive } from 'vue'
import { RouterView } from 'vue-router'
import { useConfigStore } from '@/store/config.store'
import { workTimeOrCountApi } from './api/common.api'
import emitter from './utils/mitt'
import advWindow from '@/components/advWindowPoper/index'
import Mobile from './views/Mobile.vue'

if (!window.localStorage.getItem('token')) {
  localStorage.setItem('LearningDuration', '{}')
}
const duration = reactive(JSON.parse(localStorage.getItem('LearningDuration') ?? '{}'))
provide('duration', duration)

const timeOrCount = workTimeOrCountApi()

// 统计学习时间
const tick = setInterval(() => {
  if (!window.localStorage.getItem('token')) {
    return
  }
  Object.assign(duration, JSON.parse(localStorage.getItem('LearningDuration') ?? '{}'))
  if (duration.updateTime && dayjs().isSame(duration.updateTime, 'm')) return
  const date = dayjs().format('YYYY-MM-DD')
  if (date === duration.date) {
    duration.today++
    timeOrCount.countTime(60)
  } else {
    duration.today = 0
    duration.date = date
  }
  duration.total++
  duration.updateTime = new Date().valueOf()
  localStorage.setItem('LearningDuration', JSON.stringify(duration))
}, 60000)
onBeforeUnmount(() => clearInterval(tick))
useConfigStore().getNewWxInfoApi() //获取回流二维码

const emit = emitter

const isMobile = () => {
  return false
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

onMounted(() => {
  emit.on('openWindowPopup', (value: number | boolean) => {
    advWindow(value)
  })
})
</script>

<style lang="scss"></style>
